
const TimeService = {
    isValidLocalTime(offset: number, offsetThreshold: number): boolean {
        console.log("[TimeService] offset offsetThreshold ", offset, offsetThreshold)
        if(offset > offsetThreshold || (offset * -1) > offsetThreshold) {
          return false;
        } else {
          return true;
        }
    },
    getNowUTC(): Date {
        var date = new Date();
        var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
          date.getUTCDate(), date.getUTCHours(),
          date.getUTCMinutes(), date.getUTCSeconds());
        
        return new Date(now_utc);
      },
      convertDateToUTC(date: Date): Date {
        var utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
          date.getUTCDate(), date.getUTCHours(),
          date.getUTCMinutes(), date.getUTCSeconds());
        
        return new Date(utc);
      },
    timeZone:()=>{
        console.log(`[TimeService][current timezone][${Intl.DateTimeFormat().resolvedOptions().timeZone}]`);  
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    current: ()=>{
        var d = new Date();
        TimeService.timeZone();
        return d.toString();
    },
    init: (cb:any)=>{
        TimeService.timeZone();
           setInterval(()=>{
            var d = new Date();
           cb(d.toLocaleString());
       },1000)
    }
    }
    
    export default TimeService;
      